import t from 'tcomb-form';

import cleanedType from './clean';


const SmartInt = cleanedType('SmartNum', t.Num, function (x) {
    return parseInt(x, 10) > 0;
});

export default SmartInt;



/** WEBPACK FOOTER **
 ** ./app/src/forms/validators/SmartInt.js
 **/